import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";

function FirstPageViewer({ fileUrl }) {
  const canvasRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const loadAndRender = async () => {
      // pdf.js yüklü değilse yükle
      if (!window.pdfjsLib) {
        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
      window.pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
      try {
        const loadingTask = window.pdfjsLib.getDocument(fileUrl);
        const pdf = await loadingTask.promise;
        const page = await pdf.getPage(1);
        const scale = 1;
        const viewport = page.getViewport({ scale });
        const canvas = canvasRef.current;
        if (!canvas) return;
        const context = canvas.getContext("2d");
        if (!context) return;
        canvas.width = 198;
        canvas.height = 280;
        const scaleX = 198 / viewport.width;
        const scaleY = 280 / viewport.height;
        const fitScale = Math.min(scaleX, scaleY);
        const fitViewport = page.getViewport({ scale: fitScale });
        context.clearRect(0, 0, canvas.width, canvas.height);
        await page.render({ canvasContext: context, viewport: fitViewport }).promise;
      } catch (e) {
        const canvas = canvasRef.current;
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
    };
    loadAndRender();
  }, [fileUrl, isVisible]);

  return (
    <SuiBox ref={containerRef} sx={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <canvas
        ref={canvasRef}
        width={198}
        height={280}
        style={{
          display: "block",
          borderRadius: "8px",
          background: isVisible ? "#f5f5f5" : "#e0e0e0",
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
      {!isVisible && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#666",
            fontSize: "12px",
          }}
        >
          Yükleniyor...
        </div>
      )}
    </SuiBox>
  );
}

FirstPageViewer.propTypes = {
  fileUrl: PropTypes.string.isRequired,
};

export default FirstPageViewer;
